module.exports = __webpack_public_path__ + "static/media/assembly6.b67de053.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/assembly6.png
// module id = 2424
// module chunks = 0